import { UiPopoverService } from "./ui-popover.service";

export { UiPopoverService };

export default [UiPopoverService];
